<template>
  <DefaultLayout>
    <template v-slot:header>
      <CoastHeader :hasBackButton="true" :is-modal="!!selectedDraft"  :title="$t('Wildlife Reports')"></CoastHeader>
    </template>
    <FormControl @onSubmit="handleSubmit" autocomplete="off" ref="FormControl">
      <FieldWrapper ionItemClass="camera-item" name="files">
        <UploadImage @input="setImages" :images="files"></UploadImage>
      </FieldWrapper>

      <FieldWrapper>
        <ion-text lines="none" color="primary">
          Current Date: {{ currentDatetime.date }}, {{ formatAMPM(currentDatetime.time) }}
        </ion-text>
      </FieldWrapper>

      <ion-item class="submission-text" lines="none">
        <ion-row>
          <ion-text>{{ $t('Was the observation date different?') }}</ion-text>
          <ion-text @click="toggleDatetime(true)" class="add" color="primary" v-if="!differentDate">
            {{ $t('+ Add another date') }}
          </ion-text>
          <ion-text @click="toggleDatetime(false)" class="add" color="primary" v-else>
            {{ $t('- Remove the observation date') }}
          </ion-text>
        </ion-row>
      </ion-item>

      <FieldWrapper v-if="differentDate" :label="$t('Date *')" ionItemClass="border-full" name="submitted_at">
        <ion-datetime :placeholder="$t('Select Date')" @ionChange="hideError('submitted_at')"
                      presentation="month-day-year"
                      v-model="datetime.date"></ion-datetime>
        <Calendar class="date-icon"></Calendar>
      </FieldWrapper>

      <FieldWrapper v-if="differentDate" :label="$t('Time *')" ionItemClass="border-full" name="submitted_at">
        <ion-datetime :placeholder="$t('Select Time')" @ionChange="hideError('submitted_at')" display-format="HH:mm"
                      v-model="datetime.time"></ion-datetime>
        <Time class="time-icon"></Time>
      </FieldWrapper>

      <FieldWrapper :label="$t('Do you see a species at risk?*')" ionItemClass="border-full" name="species_at_risk">
        <ion-radio-group @ionChange="hideError('species_at_risk')" class="radio-group" v-model="form.species_at_risk">
          <ion-item class="coast-radio" lines="none">
            <ion-radio :value="'Yes'" slot="start"></ion-radio>
            <ion-label>{{$t('Yes')}}</ion-label>
          </ion-item>

          <ion-item class="coast-radio" lines="none">
            <ion-radio :value="'No'" slot="start"></ion-radio>
            <ion-label>{{$t('No')}}</ion-label>
          </ion-item>

          <ion-item class="coast-radio" lines="none">
            <ion-radio :value="'Not sure'" slot="start"></ion-radio>
            <ion-label>{{$t('Not sure')}}</ion-label>
          </ion-item>
        </ion-radio-group>
      </FieldWrapper>


      <FieldWrapper :label="$t('What species do you see?*')" ionItemClass="border-full" name="species_name">
        <ion-select multiple="true" :placeholder="$t('Select')" @ionChange="hideError('species_name')" interface="action-sheet"
                    v-model="form.species_name">
          <ion-select-option :key="i" :value="i" v-for="i in species">{{i}}</ion-select-option>
        </ion-select>
        <ChevronDown class="chevron-down-icon"></ChevronDown>
      </FieldWrapper>

      <FieldWrapper v-if="form.species_name && form.species_name.includes('Other')" :label="$t('Other')" ionItemClass="border-full"
                    name="species_name_other">
        <ion-input :placeholder="$t('Other')" @ionChange="hideError('species_name_other')"
                   v-model="form.species_name_other"></ion-input>
      </FieldWrapper>

      <template :key="index" v-for="(item, index) in form.species_name">
        <FieldWrapper :label="$t((form.species_name[index] === 'Other' ? form.species_name_other ? form.species_name_other : 'Other' : item) + ' Number of Individuals *')" ionItemClass="border-full" name="individuals_number">
          <ion-input inputmode="numeric" type="number" :placeholder="$t('Number of Individuals')" @ionChange="hideError('individuals_number')" interface="action-sheet"
                     v-model="form.individuals_number[index]">
          </ion-input>
        </FieldWrapper>

        <FieldWrapper :label="$t((form.species_name[index] === 'Other' ? form.species_name_other ? form.species_name_other : 'Other' : item) + ' Alive *')" ionItemClass="border-full" name="alive">
          <ion-input :placeholder="$t('Alive')" @ionChange="hideError('alive')" interface="action-sheet" inputmode="numeric" type="number" min="0"
                     v-model="form.alive[index]">
          </ion-input>
        </FieldWrapper>

        <FieldWrapper :label="$t((form.species_name[index] === 'Other' ? form.species_name_other ? form.species_name_other : 'Other' : item) + ' Deceased *')" ionItemClass="border-full" name="deceased">
          <ion-input :placeholder="$t('Deceased')" @ionChange="hideError('deceased')" interface="action-sheet" inputmode="numeric" type="number" min="0"
                     v-model="form.deceased[index]">
          </ion-input>
        </FieldWrapper>

        <FieldWrapper :label="$t((form.species_name[index] === 'Other' ? form.species_name_other ? form.species_name_other : 'Other' : item) + ' Decomposing *')" ionItemClass="border-full" name="decomposing">
          <ion-input :placeholder="$t('Decomposing')" @ionChange="hideError('decomposing')" interface="action-sheet" inputmode="numeric" type="number" min="0"
                     v-model="form.decomposing[index]">
          </ion-input>
        </FieldWrapper>
        <ion-item v-if="form.species_name.length - 1 !== index"></ion-item>
      </template>

      <FieldWrapper :label="$t('Notes')" ionItemClass="border-full">
        <ion-textarea :placeholder="$t('Enter any notes here...')" cols="20" rows="7"
                      v-model="form.notes"></ion-textarea>
      </FieldWrapper>

      <GoogleUserLocation
          :location="{
              longitude: form.longitude,
              latitude: form.latitude
            }"
          @userLocation="setLocationToForm">
      </GoogleUserLocation>

      <ion-item class="primary-button" lines="none">
        <ion-button expand="block" type="submit">{{ $t('Submit') }}</ion-button>
      </ion-item>
      <ion-item v-if="selectedDraft" class="primary-button">
        <ion-button expand="block" @click="clearDraftAndRedirect">{{ $t('Clear Draft') }}</ion-button>
      </ion-item>
    </FormControl>
  </DefaultLayout>
</template>

<script>
  import {
    IonDatetime,
    IonItem,
    IonText,
    IonRadioGroup,
    IonRadio,
    IonLabel,
    IonTextarea,
    IonInput,
    IonSelect,
    IonSelectOption,
    IonRow,
    IonButton
  } from '@ionic/vue'
  import DefaultLayout from "@/views/layouts/default.vue"
  import CoastHeader from "@/components/CoastHeader.vue"
  import GoogleUserLocation from "@/components/GoogleUserLocation.vue"
  import Calendar from "@/components/icons/Calendar.vue"
  import Time from "@/components/icons/Time.vue"
  import ChevronDown from "@/components/icons/ChevronDown.vue"
  import FormControl from "@/components/FormControl"
  import FieldWrapper from "@/components/FieldWrapper"
  import UploadImage from "@/components/UploadImage"
  import '@/theme/components/form.scss'
  import moment from "moment"
  import ApiService from "@/services/api.service";
  import {mapGetters} from "vuex";
  import {alertController, modalController} from "@ionic/core";
  import CongratulationModal from "@/components/CongratulationModal";
  import { Device } from '@capacitor/device';
  import InteractsWithDrafts from "@/mixins/InteractsWithDrafts";
  import cloneDeep from "lodash/cloneDeep";

  export default {
    name: "WildlifeReport",
    mixins: [InteractsWithDrafts],
    components: {
      IonDatetime,
      IonItem,
      IonText,
      IonRadioGroup,
      IonRadio,
      IonLabel,
      IonTextarea,
      IonInput,
      IonSelect,
      IonSelectOption,
      IonRow,
      IonButton,
      FormControl,
      FieldWrapper,
      UploadImage,
      DefaultLayout,
      CoastHeader,
      Calendar,
      Time,
      ChevronDown,
      GoogleUserLocation
    },

    data() {
      return {
        form: {
          'individuals_number': [],
          'alive': [],
          'decomposing': [],
          'deceased': []
        },
        currentDatetime: {
          date: `${moment(new Date()).format('MMMM')} ${moment(new Date()).format('D-Y')}`,
          time: new Date()
        },
        datetime: {
          date: null,
          time: null
        },
        differentDate: false,
        files: [],
        species: [
          'Gull',
          'Canada Geese',
          'Mallard',
          'Merganser',
          'Cormorant',
          'Swan',
          'Crow',
          'Kingfisher',
          'Northern Flicker',
          'Blue Jay',
          'Bald Eagle',
          'Piping Plover',
          'Monarch Butterfly',
          'Gobe',
          'Zebra Mussel',
          'Quagga Mussel',
          'Other'
        ],
        errors: []
      }
    },

    computed: {
      ...mapGetters("auth", ["user"]),
      localError () {
        return {
          "species_name": ["The species name field is required."],
          "species_at_risk": ["The species at risk field is required."],
          ...(this.form.species_name?.length ? {
            "individuals_number": ["The individuals number field is required."],
            "alive": ["The alive field is required."],
            "deceased": ["The deceased field is required."],
            "decomposing": ["The decomposing field is required."]
          } : {}),
        }
      }
    },

    created () {
      this.restoreObservationDate();
    },

    beforeRouteLeave(to, from , next) {
      return this.handleBeforeRouteLeave(to, from , next);
    },

    methods: {
      async handleSubmit() {
        const data = new FormData()
        const form = cloneDeep(this.form)

        const deviceInfo = await this.getDeviceInfo();
        data.append('device', JSON.stringify(deviceInfo));

        if (this.datetime && this.datetime.time && this.datetime.date) {
          data.append('submitted_at', this.formattedDates(this.datetime))
        }

        if (this.files) {
          this.files.forEach(image => {
            data.append('files[]', image.file, image.file.name)
          })
        }

        data.append('form_type', this.$options.name)

        data.append('user_id', this.user.id)

        if (form?.species_name_other) {
          for (const index in form.species_name) {
            if (form.species_name[index] === 'Other') {
              form.species_name[index] = form.species_name_other
            }
          }
          delete form.species_name_other
        }

        if(form?.individuals_number.length) {
          for (const index in form.species_name) {
            if (!form.individuals_number[index]) {
              form.individuals_number[index] = 0
            }
          }
        }

        if(form?.alive.length) {
          for (const index in form.species_name) {
            if (!form.alive[index]) {
              form.alive[index] = 0
            }
          }
        }

        if(form?.deceased.length) {
          for (const index in form.species_name) {
            if (!form.deceased[index]) {
              form.deceased[index] = 0
            }
          }
        }

        if(form?.decomposing.length) {
          for (const index in form.species_name) {
            if (!form.decomposing[index]) {
              form.decomposing[index] = 0
            }
          }
        }

        for (const [key, value] of Object.entries(form)) {
          data.append(key, value)
        }

        if (!navigator.onLine) {
          const errKeys = Object.keys(this.localError)
          const formKeys = Array.from(data.keys())
          const diff = errKeys.filter(x => !formKeys.includes(x));
          const errors = {}

          diff.map((index) => {
            errors[index] = this.localError[index]
          })

          this.errors = errors
          this.$refs.FormControl.setErrors(errors)

          if (Object.keys(errors).length) {
            const errorAlert = await alertController.create({
              header: this.$t('Failed to submit'),
              subHeader: this.$t('The data was invalid'),
              message: this.$t('Please fill all the required fields'),
              buttons: [this.$t('OK')]
            });

            await errorAlert.present()

            return
          }
        }

        // If there's no internet, inform the user, save as draft and don't attempt to submit
        await this.checkInternetConnection();

        try {
          await ApiService.post('/submission', data)
            .then(() => {
              this.persistObservationDate()
              this.openModal()
              this.$store.dispatch('auth/getUser')
            })

            .catch(async (err) => {
              const errorAlert = await alertController.create({
                header: this.$t('Failed'),
                subHeader: this.$t('Submission Failed'),
                message: err.response.data.message,
                buttons: [this.$t('OK')]
              });

              if (err.response?.data?.errors) {
                this.$refs.FormControl.setErrors(err.response.data.errors)
                this.errors = err.response.data.errors
              }

              await errorAlert.present()
            })
        } catch (err) {
          const errorAlert = await alertController.create({
            header: this.$t('Failed to submit'),
            subHeader: this.$t('No Internet Connection'),
            message: this.$t('Your report will be stored and sent once you will be online'),
            buttons: [this.$t('OK')]
          });

          await errorAlert.present()
        }
        this.clearDraft();
      },

      formattedDates() {
        if (this.datetime && this.datetime.date && this.datetime.time) {
          const time = new Date(this.datetime.time);
          return moment(this.datetime.date)
              .set('hour', time.getHours())
              .set('minutes', time.getMinutes())
              .set('seconds', time.getSeconds())
              .toISOString()
        }
      },

      formatAMPM(date) {
        let hours = date.getHours();
        let minutes = date.getMinutes();
        const ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        return hours + ':' + minutes + ' ' + ampm;
      },

      setLocationToForm(data) {
        if (data.longitude) {
          this.form.longitude = data.longitude
        }

        if (data.latitude) {
          this.form.latitude = data.latitude
        }
      },

      setImages(data) {
        this.files = [...data]
      },

      toggleDatetime(value) {
        this.differentDate = value
      },

      async openModal() {
        const modal = await modalController
          .create({
            component: CongratulationModal,
            componentProps: {
              resetForm: () => { this.form = {}; this.files = []; },
            },
            cssClass: 'success',
            backdropDismiss:false
          });
        return await modal.present();
      },

      hideError(key) {
        if (key === 'created_at') {
          if (this.dates[0] && this.dates[0].date && this.dates[0].time) {
            delete this.errors[key]
            this.$refs.FormControl.setErrors(this.errors)
          }
        } else {
          delete this.errors[key]
          this.$refs.FormControl.setErrors(this.errors)
        }
      },
      async getDeviceInfo() {
        return await Device.getInfo();
      }
    }
  }
</script>

<style scoped>

</style>
